import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetails } from '../components/ProductDetails';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-100 text-burgundy-900 font-sans selection:bg-burgundy-200 selection:text-burgundy-900" data-id="element-261">
      <main data-id="element-262">
        <Hero data-id="element-263" />
        <ProblemSection data-id="element-264" />
        <SolutionSection data-id="element-265" />
        <ProductDetails data-id="element-266" />
        <PricingSection data-id="element-267" />
      </main>
      <Footer data-id="element-268" />
    </div>;
}